<template>
  <Teleport to="body">
    <TransitionGroup name="toast" tag="div" class="toast-container">
      <div
        v-for="msg in messages"
        :key="msg.id"
        :class="['toast-item', msg.type]"
        @click="dismiss(msg.id)"
      >
        {{ msg.text }}
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<script setup>
import { ref } from "vue";

const messages = ref([]);
let nextId = 0;

function show(text, type = "error", duration = 4000) {
  const id = ++nextId;
  messages.value.push({ id, text, type });
  if (duration > 0) {
    setTimeout(() => dismiss(id), duration);
  }
}

function dismiss(id) {
  const idx = messages.value.findIndex((m) => m.id === id);
  if (idx !== -1) messages.value.splice(idx, 1);
}

defineExpose({ show, dismiss });
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}
.toast-item {
  padding: 14px 24px;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  pointer-events: auto;
  max-width: 380px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.toast-item.error {
  background: #ef4444;
}
.toast-item.success {
  background: #22c55e;
}
.toast-item.warning {
  background: #f59e0b;
}
.toast-enter-active {
  transition: all 0.3s ease;
}
.toast-leave-active {
  transition: all 0.2s ease;
}
.toast-enter-from {
  transform: translateX(100%);
  opacity: 0;
}
.toast-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
